import React from 'react';
import { Box, Heading, useColorModeValue } from '@chakra-ui/react';

const CollapsibleSection = ({ title, isOpen, onToggle, children }) => {
  const bgColor = useColorModeValue('white', 'background.shade2');
  const hoverBgColor = useColorModeValue('background.shade2', 'background.shade3');

  return (
    <>
      <Box
        bg={bgColor}
        p={4}
        borderRadius="md"
        cursor="pointer"
        border="1px solid"
        borderColor="border.default"
        boxShadow="subtle"
        _hover={{ bg: hoverBgColor }}
        onClick={onToggle}
      >
        <Heading as="h2" textStyle="h2" textAlign="center">
          {title}
        </Heading>
      </Box>
      {isOpen && (
        <Box mt={4}>
          {children}
        </Box>
      )}
    </>
  );
};

export default CollapsibleSection;
